module.exports = __webpack_public_path__ + "static/MticNewLogo-0be9281cb380de44d96c466be593110a.svg";